"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidNumber = exports.impermanentLoss = exports.toAPR = void 0;
function toAPR(n) {
    const SECONDS_IN_YEAR = 365 * 24 * 3600;
    return n * SECONDS_IN_YEAR;
}
exports.toAPR = toAPR;
function impermanentLoss(priceSwing) {
    return Math.sqrt(priceSwing) / (priceSwing + 1) * 2;
}
exports.impermanentLoss = impermanentLoss;
function isValidNumber(n) {
    return !(n === null || n === undefined || isNaN(n));
}
exports.isValidNumber = isValidNumber;
